const staticContent = Array.from(
  { length: (55 - 10) / 5 },
  (_, i) => `${10 + i * 5}%`
);
module.exports = staticContent;
